import styled, { css, keyframes } from "styled-components";
import { accentColor, AccentedText, bodyTextBold, bodyTextRegular, Section } from "../layout/style";
import SampleSensorData from "../data/sample-data.json";
import { useState, useEffect } from "react";

const ContentContainer = styled.div`
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 20px;
margin-top: 50px;
margin-bottom: 50px;
`;

const ColumnContainer = styled.div`
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;

`;

const ColumnLeft = styled(ColumnContainer)`
    flex: 1 0 60%;
    width: 60%;

`;

const ColumnRight = styled(ColumnContainer)`
    flex: 1 0 40%;
    width: 40%;
    // justify-content: flex-start;
`;


const RestyledSection = styled(Section)`
    padding: 0px;

    // margin: 0px;

    & p {
        margin: 0px;
    }

`;




const VisualAttributesContainer = styled.div`
    display: flex:
    flex-direction: column;
`;

const VisualAttributesRow = styled.div`
    display: flex;
    flex-direction: row;
    height: 60px;
    align-items: center;
    margin-bottom: 15px;
`;

const VisualAttributesHeader = styled.h2`
    flex: 1 0 40%;
    width: 40%;
    text-align: right;
        font-size: 1rem;
    // color: ${accentColor};
    padding-bottom: 5px;
    margin: 0px;
    margin-bottom: 5px;

    ${bodyTextBold}
`;




const VisualAttributesAnimation = styled.div`
    flex: 1 0 60%;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    margin-left: 100px;
`;

const visibilityAnimation = keyframes`
    to {
        visibility: hidden;
    }
`;

const sizeAnimation = keyframes`
    0% {
        width: 10px;
        height: 10px;
    }

    50% {
        width: 30px;
        height: 30px;
    }

    100% {
        width: 10px;
        height: 10px;
    }
`;

const opacityAnimation = keyframes`
    0% {
        opacity: 0.1;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0.1;
    }
`;

const horizontalMovementAnimation = keyframes`
    0% {
        margin-left: -30px;
    }

    50% {
        margin-left: 30px;
    }

    100% {
        margin-left: -30px;
    }
`;

const verticalMovementAnimation = keyframes`
    0% {
        margin-top: -30px;
    }

    50% {
        margin-top: 30px;
    }

    100% {
        margin-top: -30px;
    }
`;

const filteredMovementAnimation = keyframes`

    0% {
        margin-left: -30px;
        margin-top: -30px;
    }

    10% {
        margin-left: -30px;
        margin-top; 0px;
    }

    20% {
        margin-left: -30px;
        margin-top: 30px;
    }

    30% {
        margin-left: -30px;
        margin-top: 0px;
    }

    40% {
        margin-left: 0px;
        margin-top: 0px;
    }

    50% {
        margin-left: 30px;
        margin-top: 0px;
    
    }

    60% {
        margin-left: 0px;
        margin-top: 0px;
    }

    70% {
    
        margin-left: -30px;
        margin-top: 0px;

    }

    80% {
        margin-left: 0px;
        margin-top: 0px;
    
    }

    90% {
        margin-left: -30px;
        margin-top: 0px;
    }

    100% {
        margin-left: -30px;
        margin-top: -30px;
    }



`;

const Circle = styled.div`
    width: 25px;
    height: 25px;
    // background-color: ${accentColor};
    background-color: #333333;
    border-radius: 50%;
    display: inline-block;

    &.visibility {
        animation: ${visibilityAnimation} 1s steps(2, start) infinite;
    }

    &.size {
        animation: ${sizeAnimation} 2s infinite;
    }

        &.opacity {
        animation: ${opacityAnimation} 2s infinite;
    }

            &.horizontalMovement {
        animation: ${horizontalMovementAnimation} 2s infinite;
    }

                &.verticalMovement {
        animation: ${verticalMovementAnimation} 2s infinite;
    }

    &.combinedMovement {
        animation: ${horizontalMovementAnimation} 2s infinite, ${verticalMovementAnimation} 2.5s infinite;
    }

    &.filteredMovement {
        animation: ${filteredMovementAnimation} 3s infinite linear;
    }
`;

const SpacerHeader = styled.h2`
    ${bodyTextBold}
    color: ${accentColor};
    font-size: 1.3rem;
    margin: 0px;
`;

const SensorDataContainer = styled.div`
    width: 100%;
    margin: 0px;
    margin-bottom: 20px;
`;


const DataSampleContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const DataSampleRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    // background-color: rgba(255,255,255, 0.5);
    padding: 5px;
    font-size: 10pt;



`;

const DataSampleRowLabel = styled.span`
    display: block;
    margin-right: 5px;

    font-family: Consolas,monaco,monospace;
    font-weight: bold;

    &:first-of-type {
        margin-left: 4px;
    }
`;

const DataSampleRowValue = styled.span`
    display: block;
    margin-right: 5px;
    font-family: Consolas,monaco,monospace;
    min-width: 100px;

`;

const wearableLabels = new Map([
    [0, "Glove-1"],
    [4, "Glove-2"],
    [8, "Glove-3"],
    [12, "Glove-4"],
    [16, "Foot-1"],
    [20, "Foot-2"],
    [124, "Foot-3"],
]);

const displaySampleData = (input) => {
    const [time, channel, values] = input;

    return <>
        <DataSampleRowLabel>Time</DataSampleRowLabel>
        <DataSampleRowValue>{Math.round((time - 1696344902687) / 1000 * 1000) / 1000}s</DataSampleRowValue>
        <DataSampleRowLabel>Wearable</DataSampleRowLabel>
        <DataSampleRowValue>{wearableLabels.get(channel)}</DataSampleRowValue>
        <DataSampleRowLabel>Signal</DataSampleRowLabel>
        <DataSampleRowValue>{values.join(" / ")}</DataSampleRowValue>
    </>;

}

const FilteredSampleSensorData = SampleSensorData.data.filter((d) => {
    const [time, channel, values] = d;
    return values.length > 0;
}).slice(0, 200);

const totalSampleDataCount = FilteredSampleSensorData.length;


const DataSample = ({ currentDatumIndex }) => {

    let datumIndices;
    const displayCount = 4;
    if (currentDatumIndex + displayCount < totalSampleDataCount) {
        datumIndices = Array.from(new Array(displayCount), (x, i) => i + currentDatumIndex);
    } else {
        datumIndices = Array.from(new Array(displayCount), (x, i) => (i + currentDatumIndex) % totalSampleDataCount)
    }

    return <DataSampleContainer>
        {datumIndices.map(di => {
            const sampleDatum = FilteredSampleSensorData[di];

            return <DataSampleRow key={`data_sample_${di}`}>{displaySampleData(sampleDatum)}</DataSampleRow>
        })}
    </DataSampleContainer>;
}


const VisualAttributes = () => {

    return <VisualAttributesContainer>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Visibility
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="visibility" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Size
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="size" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Opacity
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="opacity" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Horizontal Movement
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="horizontalMovement" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Vertical Movement
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="verticalMovement" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Combined Movement
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="combinedMovement" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>
        <VisualAttributesRow>
            <VisualAttributesHeader>
                Filtering Movement Direction
            </VisualAttributesHeader>
            <VisualAttributesAnimation>
                <Circle className="filteredMovement" />
            </VisualAttributesAnimation>
        </VisualAttributesRow>

    </VisualAttributesContainer>;


}

const VisualizationDiscussionSlide = () => {
    const [datumIndex, setDatumIndex] = useState(0);

    useEffect(() => {

        const interval = setInterval(() => {

            setDatumIndex(currentDatumIndex => currentDatumIndex + 1);

        }, 500);
        return () => clearInterval(interval);

    }, []);

    return <ContentContainer>
        <ColumnLeft>
            <RestyledSection>
                <p>With each study, new kinesthetic information becomes available – but in ways that are invisible to outside observers who are watching the movement. This invisibility is one of the core considerations of <i>Proxies</i>: <b>What does it mean to render these kinesthetic dimensions of physical interaction visible to those outside the system?</b> In <i>Proxies</i>, data are collected by the wearable sensors during performance on duration and intensity of pressure. These data can be represented in real time through many modalities, including sound, haptics, and visualization. Ongoing investigations have focused on one of these modalities in particular: data visualization.</p>
                <p>Kinesthetic experience provides a system of information through skin, muscle, and bone that is inherently embodied. <b>What would it look like for a visualization of data about kinesthetic experience to capture and communicate this embodied system of information, through visual form?</b> Visualization, as a system of representation constructed from encodings through marks and channels, has its own mode of expressivity that is quite different: it is representational and abstracted. These differences yield a source of <strong>aesthetic conflict</strong> – tensions that arise when contrasting styles, themes, or artistic media interact in unexpected or challenging ways – that must be addressed when translating between embodied experience and visual representation.</p>
                <p>Current investigations are exploring how visualization could be used to overcome this aesthetic conflict through expressive rather than representational means. For example, consider a simple mark, such as a circle. A circle can take on a range of attributes, each of which communicates new levels of structured information. A circle’s visibility, its size and opacity, the way it moves both horizontally and vertically, if at all: These are degrees of freedom that open up new possibilities of movement and identity for the circle. If we map changes in structural information from embodied, kinesthetic experience to changes in <i>which</i> of these visual attributes of simple marks are expressed, perhaps visualization can be used to render visible nuance and subtlety that would be otherwise invisible to outside observation.</p>
                <p>Importantly, the purpose of visualization in this sense is not just to directly map data about movement to a visualization that captures the mechanics of that movement in high fidelity – in that case, the highest-fidelity source is watching the movement itself! Instead, we consider how visualization might be used to prime awareness and attention toward nuanced shifts in quality of movement, so that such attention might be directed back toward our own kinesthetic experience in our body. </p>
            </RestyledSection>
        </ColumnLeft>
        <ColumnRight>
            <SpacerHeader>Translating real-time sensor data...</SpacerHeader>
            <SensorDataContainer>
                <DataSample currentDatumIndex={datumIndex % FilteredSampleSensorData.length} />
            </SensorDataContainer>
            <SpacerHeader>...to degrees of freedom in visual attributes:</SpacerHeader>
            <VisualAttributes />
        </ColumnRight>
    </ContentContainer>
}

export default VisualizationDiscussionSlide;